// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainBefore } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    SendTracking,
} from "@insite/client-framework/Store/Components/ProductRecommendations/Handlers/PrepareTrack";
import { getSettingsCollection } from "@mcmc/App/Store/Selectors/SettingsSelectors";

// XNG-Changes: XSD-12838 - Depending on a customSetting, avoid sendTracking when peeruis is not loaded
export const XngSendTracking: typeof SendTracking = ({ getState }) => {
    const isPeeriusLoaded = getState().components.productRecommendations.isPeeriusLoaded;
    const customSettings = getSettingsCollection(getState())?.customSettings;
    const allowPeeriusUnhandledErrors = customSettings?.allowPeeriusUnhandledErrors?.toLowerCase() === "true";

    if (!allowPeeriusUnhandledErrors && !isPeeriusLoaded) {
        return false;
    }
};

addToChainBefore(chain, SendTracking, XngSendTracking);
